window.tinymce.PluginManager.add('position', function(editor) {
    let element, rect, body, containerRect;
    {
        const mousemove = event => {
            element.style.position = 'absolute';
            element.style.top = Math.max(event.clientY - containerRect.top - rect.height / 2, 0) + 'px';
            element.style.left = Math.min(
                Math.max(event.clientX - containerRect.left - rect.width / 2, 0),
                containerRect.width - rect.width,
            ) + 'px';
        };
        const mouseup = () => {
            body.removeEventListener('mousemove', mousemove);
            body.removeEventListener('mouseup', mouseup);
        };
        editor.addButton('toggle_position', {
            tooltip: window.gettext('Position'),
            onmousedown(event) {
                element = editor.selection.getNode();
                body = editor.getBody();
                if (!element || element === body)
                    return;
                while (element !== body && element.style.position !== 'absolute')
                    element = element.parentElement;
                if (element === body)
                    element = editor.selection.getNode();
                if (element instanceof HTMLIFrameElement)
                    element = element.parentElement;
                if (element instanceof HTMLParagraphElement)
                    return;
                if (event.altKey) {
                    const win = editor.windowManager.open({
                        title: window.gettext('Position'),
                        items: {
                            type: 'container',
                            layout: 'flex',
                            direction: 'row',
                            align: 'stretch',
                            padding: 5,
                            spacing: 10,
                            items: {
                                type: 'form',
                                padding: 0,
                                labelGap: 5,
                                defaults: {
                                    type: 'textbox',
                                    size: 7,
                                    flex: 1,
                                    spellcheck: false,
                                    onkeyup() {
                                        const name = this.name(), value = this.value();

                                        if (isNaN(Number.parseInt(value)))
                                            return;

                                        if (name === 'top') {
                                            element.style.top = isNaN(Number(value)) ? value : value + 'px';
                                            element.style.bottom = '';
                                            win.find('#bottom').value('');
                                        }
                                        else if (name === 'bottom') {
                                            element.style.bottom = isNaN(Number(value)) ? value : value + 'px';
                                            element.style.top = '';
                                            win.find('#top').value('');
                                        }
                                        else if (name === 'left') {
                                            element.style.left = isNaN(Number(value)) ? value : value + 'px';
                                            element.style.right = '';
                                            win.find('#right').value('');
                                        }
                                        else if (name === 'right') {
                                            element.style.right = isNaN(Number(value)) ? value : value + 'px';
                                            element.style.left = '';
                                            win.find('#left').value('');
                                        }
                                    },
                                },
                                items: [
                                    {name: 'top', label: window.gettext('Top'), value: element.style.top.replace('px', ''), autofocus: 1},
                                    {name: 'left', label: window.gettext('Left'), value: element.style.left.replace('px', '')},
                                    {name: 'bottom', label: window.gettext('Bottom'), value: element.style.bottom.replace('px', '')},
                                    {name: 'right', label: window.gettext('Right'), value: element.style.right.replace('px', '')},
                                ],
                            },
                        },
                        onSubmit() {
                            element.getBoundingClientRect();
                        },
                    });
                }
                else {
                    containerRect = body.getBoundingClientRect();
                    rect = element.getBoundingClientRect();
                    body.addEventListener('mousemove', mousemove);
                    body.addEventListener('mouseup', mouseup);
                }
            },
            onmouseup() {
                element.style.position = '';
                element.style.top = '';
                element.style.left = '';
                mouseup();
            },
            icon: 'custom fa-arrows',
        });
    }

    {
        const mousemove = event => {
            element.style.position = 'absolute';
            element.style.height = Math.max(event.clientY - rect.top, 0) + 'px';
            element.style.width = Math.max(event.clientX - rect.left, 0) + 'px';
        };
        const mouseup = () => {
            body.removeEventListener('mousemove', mousemove);
            body.removeEventListener('mouseup', mouseup);
        };
        editor.addButton('toggle_size', {
            tooltip: window.gettext('Resize'),
            onmousedown(event) {
                element = editor.selection.getNode();
                body = editor.getBody();
                if (!element || element === body)
                    return;
                while (element !== body && element.style.position !== 'absolute')
                    element = element.parentElement;
                if (element === body)
                    element = editor.selection.getNode();
                if (element instanceof HTMLIFrameElement)
                    element = element.parentElement;
                if (element instanceof HTMLParagraphElement)
                    return;
                if (event.altKey) {
                    editor.windowManager.open({
                        title: window.gettext('Resize'),
                        items: {
                            type: 'container',
                            layout: 'flex',
                            direction: 'row',
                            align: 'stretch',
                            padding: 5,
                            spacing: 10,
                            items: {
                                type: 'form',
                                padding: 0,
                                labelGap: 5,
                                defaults: {
                                    type: 'textbox',
                                    size: 7,
                                    flex: 1,
                                    spellcheck: false,
                                    onkeyup() {
                                        const name = this.name(), value = this.value();

                                        if (isNaN(Number.parseInt(value)))
                                            return;

                                        if (name === 'width') {
                                            element.style.width = isNaN(Number(value)) ? value : value + 'px';
                                        }
                                        else if (name === 'height') {
                                            element.style.height = isNaN(Number(value)) ? value : value + 'px';
                                        }
                                    },
                                },
                                items: [
                                    {name: 'width', label: window.gettext('Width'), value: element.style.width.replace('px', ''), autofocus: 1},
                                    {name: 'height', label: window.gettext('Height'), value: element.style.height.replace('px', '')},
                                ],
                            },
                        },
                        onSubmit() {
                            element.getBoundingClientRect();
                        },
                    });
                }
                else {
                    containerRect = body.getBoundingClientRect();
                    rect = element.getBoundingClientRect();
                    body.addEventListener('mousemove', mousemove);
                    body.addEventListener('mouseup', mouseup);
                }
            },
            onmouseup() {
                element.style.width = '';
                element.style.heigt = '';
                mouseup();
            },
            icon: 'custom fa-arrows-alt',
        });
    }

    editor.addButton('map', {
        tooltip: window.gettext('Map Generator'),
        onclick() {
            editor.windowManager.open({
                title: window.gettext('Map Generator'),
                items: {
                    type: 'container',
                    layout: 'flex',
                    direction: 'row',
                    align: 'stretch',
                    padding: 5,
                    spacing: 10,
                    items: {
                        type: 'form',
                        padding: 0,
                        labelGap: 5,
                        defaults: {
                            type: 'textbox',
                            size: 7,
                            value: '',
                            flex: 1,
                            spellcheck: false,
                        },
                        items: [
                            {name: 'latitude', label: window.gettext('Latitude')},
                            {name: 'longitude', label: window.gettext('Longitude'), autofocus: 1},
                        ],
                    },
                },
                onSubmit() {
                    const parameters = this.toJSON();
                    const mapContainer = document.createElement('span');
                    mapContainer.style.display = 'block';
                    mapContainer.style.width = '320px';
                    mapContainer.style.height = '240px';

                    const mapElement = document.createElement('iframe');
                    mapElement.classList.add('map-element');
                    mapElement.style.width = '100%';
                    mapElement.style.height = '100%';
                    mapElement.allowfullscreen = true;
                    mapElement.frameBorder = '';
                    mapElement.src = `https://www.google.com/maps/embed/v1/place?q=${parameters.latitude}%2C%20${parameters.longitude}` +
                        '&key=AIzaSyAStrjisiAtjCDdl_WwhQqDvMA65NzEpr0';
                    mapContainer.appendChild(mapElement);

                    editor.selection.setNode(mapContainer);
                },
            });
        },
        icon: 'custom fa-map-marker',
    });
});
